import { useState, useEffect, useCallback } from "react";
import WitApplyModal from "../../../common/component/WitApplyModal";
import { useNavigate } from "react-router-dom";
import chevronDown from "../../../common/assets/img/chevron-down.svg";
import BackgroundImage from "../../../common/assets/img/Girl.png";
import MbBackgroundImage from "../../../common/assets/img/mobileGirl.png";
import TimeCard from "../../../common/component/TimeCard";
import HomeNav from "../../../common/component/HomeNav";
import { navList } from "../../../common/data/menuData";
import "./style.css";
import { womenCount } from "../../../common/constants";
import WitButton from "../../../common/component/WitButton";
import {
  application,
  applicationStartDate,
  applicationEndDate,
} from "../../../common/utils/application";

function HomeComponent() {
  const navigate = useNavigate();
  const [zoomIn, setZoom] = useState(false);
  const [isVisible, setVisible] = useState(false);
  const [canApply, setCanApply] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  const handleEffect = useCallback(
    (nav = "about") => {
      setZoom(true);
      setTimeout(() => {
        navigate(`/wit#${nav}`, { state: { nav } });
      }, 500);
    },
    [navigate]
  );

  const handleModal = () => {
    if (canApply) {
      setVisible(!isVisible);
    }
  };

  useEffect(() => {
    const handleScrollDown = (e) => {
      const delta = e.deltaY ?? e.changedTouches?.[0]?.clientY;
      if (delta > 0 && !isVisible) {
        handleEffect();
      }
    };

    window.addEventListener("wheel", handleScrollDown, { passive: true });
    window.addEventListener("touchmove", handleScrollDown, { passive: true });

    return () => {
      window.removeEventListener("wheel", handleScrollDown);
      window.removeEventListener("touchmove", handleScrollDown);
    };
  }, [handleEffect, isVisible]);

  useEffect(() => {
    const countDownDate = new Date(
      application.comingSoon ? applicationStartDate : applicationEndDate
    ).getTime();

    function countDown() {
      const now = new Date().getTime();
      const distance = countDownDate - now;
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      const x = setInterval(countDown, 60000);

      if (distance < 0) {
        clearInterval(x);
        setTimeLeft({ days: "00", hours: "00", minutes: "00", seconds: "00" });
        setCanApply(false);
      } else {
        setTimeLeft({
          days: String(days).padStart(2, "0"),
          hours: String(hours).padStart(2, "0"),
          minutes: String(minutes).padStart(2, "0"),
          seconds: String(seconds).padStart(2, "0"),
        });
        setCanApply(true);
      }
    }
    countDown();

    const secondsInterval = setInterval(() => {
      const now = new Date().getTime();
      const distance = countDownDate - now;
      if (distance < 0) {
        clearInterval(secondsInterval);
        return;
      }
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      if (days < 1) {
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        setTimeLeft((prev) => ({
          ...prev,
          seconds: String(seconds).padStart(2, "0"),
        }));
      }
    }, 1000);

    return () => clearInterval(secondsInterval);
  }, []);

  return (
    <div>
      <div
        className={`background-container animate__animated animate__fadeInDown delay-2 for-desktop ${
          zoomIn ? "zoomed" : ""
        }`}
      >
        <img
          className="background-image"
          src={BackgroundImage}
          alt="background"
        />
      </div>
      <div
        className={`background-container animate__animated animate__fadeInDown delay-2 for-mobile ${
          zoomIn ? "zoomed" : ""
        }`}
      >
        <img
          className="background-image"
          src={MbBackgroundImage}
          alt="background"
        />
      </div>
      <div className={`${zoomIn ? "zoomed" : ""} home-wrap`}>
        <div className="wit-wrap h-100 wit-container" id="wit-page">
          <div className="home-content" id="page-wrap">
            <div className="home-nav-wrapper animate__animated animate__fadeInDown delay-2">
              <HomeNav />
            </div>
            {/* hero banner */}
            <section className="section-wrap hero-section" id="home-scroll">
              <div className="abt-wrapper">
                <div className="d-md-flex home-hero justify-content-center text-white">
                  <div className="text-group d-flex align-items-center animate__animated animate__fadeInLeft delay-3">
                    <div>
                      <span className="search">The search for the</span>
                      <p className="dream d-flex align-items-center">DREAM </p>
                      <span className="is-on">is on</span>
                    </div>
                    <div>
                      <span className="wit-5 pl-2">{womenCount}</span>
                    </div>
                  </div>

                  <div className="d-flex flex-column align-items-center justify-content-center countdown-wrapper animate__animated animate__fadeInRight delay-3">
                    <div className="home-hero-text">
                      {application.closed
                        ? "Application Closed"
                        : application.comingSoon
                          ? "Application opens in:"
                          : "Application closes in:"}
                    </div>
                    <div className="d-flex time-counter align-items-center">
                      {parseInt(timeLeft.days) > 0 && (
                        <TimeCard title="days" value={timeLeft.days} />
                      )}
                      <TimeCard title="hours" value={timeLeft.hours} />
                      <TimeCard title="minutes" value={timeLeft.minutes} />
                      {parseInt(timeLeft.days) < 1 && (
                        <TimeCard title="seconds" value={timeLeft.seconds} />
                      )}
                    </div>
                  </div>
                </div>
                <div className="text-center mt-1 animate__animated animate__fadeInUp delay-3 apply-now">
                  <WitButton
                    text={application.text}
                    handleClick={
                      application.canApply ? () => handleEffect("about") : null
                    }
                  />
                  <span className="my-4 scroll-down d-flex align-items-center justify-content-center">
                    <span
                      className="wit-scroll home-link"
                      onClick={() => handleEffect()}
                      data-url="./wit.html"
                    >
                      <img
                        className="wit-bounce"
                        src={chevronDown}
                        alt="chevron-down"
                      />
                    </span>
                  </span>
                </div>
              </div>
            </section>
          </div>
          <div className="wit-home-nav animate__animated animate__fadeInUp delay-2">
            {!application.comingSoon && (
              <nav className="d-flex justify-content-between w-100">
                <ul className="d-flex">
                  {navList.slice(0, 2).map((nav, index) => (
                    <li key={index}>
                      <span
                        onClick={() => handleEffect(nav)}
                        className="text-dark home-link"
                      >
                        {nav}
                      </span>
                    </li>
                  ))}
                </ul>
                <ul className="d-flex">
                  {navList.slice(-2).map((nav, index) => (
                    <li key={index}>
                      <span
                        onClick={() => handleEffect(nav)}
                        className="text-dark home-link"
                      >
                        {nav}
                      </span>
                    </li>
                  ))}
                </ul>
              </nav>
            )}
          </div>
          <WitApplyModal visible={isVisible} handleClose={handleModal} />
        </div>
      </div>
    </div>
  );
}

export default HomeComponent;
